'use client';

import { Suspense } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { ThemeProvider } from '@/components/theme-provider';
import { DEFAULT_THEME, THEME_STORAGE_KEY } from '@/lib/theme-config';
import { SessionProvider } from '@/lib/AuthContext';
import { OrganizationProvider } from '@/lib/OrganizationContext';
import { OrganizationThemeProvider } from '@/components/OrganizationThemeProvider';
import { Toaster } from '@/components/ui/sonner';
import { queryClient } from '@/lib/queryClient';
import { NavigationProgress } from '@/components/navigation/NavigationProgress';
import { PublicNavigationOverlay } from '@/components/navigation/PublicNavigationOverlay';

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider defaultTheme={DEFAULT_THEME} storageKey={THEME_STORAGE_KEY}>
        <SessionProvider>
          <OrganizationProvider>
            <OrganizationThemeProvider>
              <NavigationProgress />
              <PublicNavigationOverlay />
              <Suspense fallback={null}>{children}</Suspense>
              <Toaster />
            </OrganizationThemeProvider>
          </OrganizationProvider>
        </SessionProvider>
      </ThemeProvider>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
}
